<div class="sale-preview-email-sms-popup">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Preview Email / SMS</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <h3 [hidden]="!emailText">Email Preview</h3>
    <h3 [hidden]="!emailText">{{subject}}</h3>
    {{emailText}}
    <br />
    <h3 [hidden]="!smsText">Sms Preview</h3>
    {{smsText}}
  </div>
</div>
